<form [formGroup]="targetForm" [ngClass]="{'form-previously-submitted' : targetFormSubmitted}">
  <section class="sideRight-body">
   <h3>Delete employee</h3>
   <br />
   <table>
      <tr *ngIf="sessionService.engagementIdFocus">
          <td>Engagement ID</td>
          <td>{{sessionService.engagementIdFocus}}</td>
        </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.employeeId">
      <td>Employee ID</td>
      <td>{{rightSideDrawerService.singleRowEditData.employeeId}}</td>
    </tr> 
    <tr *ngIf="rightSideDrawerService.singleRowEditData.employeeNumber">
      <td>Employee Number</td>
      <td>{{rightSideDrawerService.singleRowEditData.employeeNumber}}</td>
    </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.name">
       <td>Name</td>
       <td>{{rightSideDrawerService.singleRowEditData.name}}</td>
     </tr>
     <tr *ngIf="rightSideDrawerService.singleRowEditData.title">
      <td>Title</td>
      <td>{{rightSideDrawerService.singleRowEditData.title}}</td>
    </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.type">
      <td>Type</td>
      <td>{{rightSideDrawerService.singleRowEditData.type}}</td>
    </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.costCenter">
      <td>Cost Center</td>
      <td>{{rightSideDrawerService.singleRowEditData.costCenter}}</td>
    </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.costCenterDesc">
      <td>Cost Center Description</td>
      <td>{{rightSideDrawerService.singleRowEditData.costCenterDesc}}</td>
    </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.location">
      <td>Location</td>
      <td>{{rightSideDrawerService.singleRowEditData.location}}</td>
    </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.hireDate">
      <td>Hire Date</td>
      <td>{{rightSideDrawerService.singleRowEditData.hireDate | date: 'MMM dd, yyyy'}}</td>
    </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.endDate">
      <td>Termination Date</td>
      <td>{{rightSideDrawerService.singleRowEditData.endDate | date: 'MMM dd, yyyy'}}</td>
    </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.totalHours">
      <td>Total Hours</td>
      <td>{{rightSideDrawerService.singleRowEditData.totalHours}}</td>
    </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.wage">
      <td>Form W-2, Box 1 Wage Amounts</td>
      <td>{{rightSideDrawerService.singleRowEditData.wage | currency}}</td>
    </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.sme">
      <td>SME</td>
      <td>{{rightSideDrawerService.singleRowEditData.sme}}</td>
    </tr>
    <tr *ngIf="rightSideDrawerService.singleRowEditData.company">
      <td>Entity</td>
      <td>{{rightSideDrawerService.singleRowEditData.company}}</td>
    </tr>
   </table>
  </section>
  <footer class="endFormSubmit info-tile">
      <button type='button' class="btn btn-danger" (click)="deleteEmployee()">Delete Employee</button>
      <button type='button' class="btn kpmg-button--flat" (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
  </footer>
</form>
